import { Box } from '@hover/blueprint';
import React, { useContext, useState } from 'react';

import scanPromoExterior from 'src/assets/img/homeownerApp/modules/linkOuts/scanPromoExterior.png';
import { DismissableCard } from 'src/modules/homeownerApp/components/Card';
import { PROJECT_DETAILS_PADDING } from 'src/modules/homeownerApp/components/Projects/Project/ProjectCardSection';
import { SectionHeader } from 'src/modules/homeownerApp/components/Projects/Project/SectionHeader';
import { useGetAppLink } from 'src/modules/homeownerApp/hooks';
import {
  HomeownerAppMenuNames,
  homeownerAppContext,
} from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export const StartScanCTA = () => {
  const { onGetAppClick } = useGetAppLink();
  const [hidden, setHidden] = useState(false);
  const { setCurrentMenu } = useContext(homeownerAppContext);

  const onSecondaryCtaClick = () => {
    setCurrentMenu(HomeownerAppMenuNames.START_SCAN_LEARN_MORE);
  };

  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  if (hidden) return null;

  return (
    <Box flexDirection="column" gap={500}>
      <SectionHeader
        header={t('projects.viewMeasurements')}
        subHeader={t('projects.whenYouAddScan')}
      />
      <DismissableCard
        backgroundImage={scanPromoExterior}
        eyebrow={t('scan.startScan.nowAvailable')}
        hasShadow
        headline={t('scan.startScan.powerEveryProject')}
        imageBoxProps={{ bgSize: 'contain' }}
        mx={PROJECT_DETAILS_PADDING}
        onClose={() => setHidden(true)}
        onPrimaryCtaClick={onGetAppClick}
        onSecondaryCtaClick={onSecondaryCtaClick}
        primaryCtaText={t('scan.learnMore.getTheApp')}
        secondaryCtaText={t('scan.learnMore.learnMore')}
        subCopy={t('scan.startScan.generateMeasurements')}
        width="auto"
      />
    </Box>
  );
};
